module.exports = __webpack_public_path__ + "static/media/g-8.45712514.jpg";